import * as Constantes from '../../../shared/constants';

// Módulos
import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

// Interfaces y Modelos
import { IUsuario } from './../../../interfaces/usuario';
import { ICampanya } from 'src/app/interfaces/campanya';
import { ICliente } from 'src/app/interfaces/cliente';
import { IListaOpciones } from 'src/app/interfaces/lista-opciones';
import { IPedido } from 'src/app/interfaces/pedido';
import {
  MCampanyaEstadosList,
  MCampanyaPreparacionEstadosList,
} from 'src/app/models/estadosList';

// Servicios
import { RepartosService } from './../../../services/datos/repartos.service';
import { CampanyasService } from 'src/app/services/datos/campanyas.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { PedidosService } from './../../../services/datos/pedidos.service';
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { ModalFactSalidaService } from 'src/app/services/modal-fact-salida.service';
import { ModalPedidoCabeceraService } from 'src/app/services/modal-pedido-cabecera.service';
import { AvisosService } from 'src/app/services/datos/avisos.service';
import { ModalAvisoPedidoService } from 'src/app/services/modal-pedido-aviso.service';

// Librerías
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import FuncLib from 'src/app/providers/funcionesLib';
import { ModalPedidoOrigenService } from 'src/app/services/modal-pedido-origen.service';

interface ILineas {
  id_articulo: number;
  ean: string;
  sku: string;
  descripcion: string;
  cantidad: number;
  cant_repartir: number;
  cant_repartida: number;
  cant_devuelta: number;
  foto?: string;
  selectOptions: {
    value: string;
    label: string;
  }[];
}

@Component({
  selector: 'app-campanyas-list',
  templateUrl: './campanyas-list.component.html',
  styleUrls: ['./campanyas-list.component.scss'],
})
export class CampanyasListComponent implements OnInit {

  // Librería de funciones
  public funcLib: FuncLib = new FuncLib();

  // Usar las constantes en el template
  Constantes = Constantes;

  public lista: ICampanya[] = [];
  public clientesList: ICliente[] = [];
  public estadosList: any[] = MCampanyaEstadosList;
  public estadosPreparacionList: any[] = MCampanyaPreparacionEstadosList;

  public eanArray: string[] = [];
  public eanSeleccionado: string = '';
  public sumaCantidadesEan: number = 0;

  selected: any = [];
  SelectionType = SelectionType;

  // Detalle de una campaña
  public campSel: ICampanya = {};
  public pedidosList: IPedido[] = [];
  public pedidosListOriginal: IPedido[] = [];

  // columnas de los pedidos de una campaña
  public sumaTotArticulos: number = 0;
  public sumaTotReferencias: number = 0;

  colPedidosLabel = [
    { key: 'id', label: 'Id', title: '' },
    { key: 'pedido_cli', label: 'Pedido', title: '' },
    { key: 'tipoPedido', label: 'Tipo', title: '' },
    { key: 'cajetin', label: 'Cajetín', title: '' },
    { key: 'albaran', label: 'Albarán', title: '' },
    { key: 'tot_articulos', label: 'Artículos', title: '' },
    { key: 'tot_referencias', label: 'Referencias', title: '' },
    { key: 'poblacion', label: 'Población', title: 'Población de destino' },
    { key: 'pais_iso', label: 'País', title: '' },
    { key: 'cod_servicio', label: 'Serv.', title: '' },
    { key: 'nombre', label: 'Nombre', title: '' },
  ];
  sortColumnPed: string = ''; // Columna actual ordenada
  sortDirectionPed: 'asc' | 'desc' = 'asc';

  // Detalle de un pedido
  public pedidoDetall: IPedido = {};

  public rows: any = [];
  public temp: any[] = [];

  public summaryPosition: string =
    localStorage.getItem('summaryPosition') || 'bottom';
  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  textoDestacado: string = '';
  public strBuscarTodo: string = '';

  textoDestacadoPedidos: string = '';
  public strBuscarTodoPedidos: string = '';

  loading: boolean = false;
  loadingAlbaran: boolean = false;

  public fotoDir: string = environment.fotoDir;
  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';

  opcionesList: IListaOpciones = {};
  cliSeleccionado: string = '';
  estadoSeleccionado: string = '';
  estadoPreparacionSeleccionado: string = '';
  pedidosSearch: string = '';
  public gurdaVistaFlag: boolean = false;

  // Control de cuando se cierra el modal
  modalClosedSubscription: Subscription | undefined;

  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: `total`,
  };

  ColumnMode = ColumnMode;
  @ViewChild(CampanyasListComponent) table: CampanyasListComponent | any;

  constructor(
    public usuarioSrv: UsuarioService,
    private campanyaSrv: CampanyasService,
    private pedidosSrv: PedidosService,
    private repartosSrv: RepartosService,
    private clientesSrv: ClientesService,
    private notificSrv: NotificacionesService,
    public modalFactSalidaSrv: ModalFactSalidaService,
    private router: Router,
    public modalPedidosCabeceraSrv: ModalPedidoCabeceraService,
    public modalAvisoPedidoSrv: ModalAvisoPedidoService,
    public modalPedidoOrigenSrv: ModalPedidoOrigenService,
    private avisosSrv: AvisosService
  ) { }

  ngOnInit(): void {
    this.estadoSeleccionado = Constantes.ESTADO_CAMPANYA_PENDIENTE; // Por defecto Recogidas pendientes

    // Mirar si xisten opciones de vista guardadas en localStore
    const opciones = this.getOpcionesListLocalStorage();
    console.log('__ngOnInit(): opciones desde localStorage:', opciones);

    if (opciones && Object.keys(opciones).length > 0) {
      this.gurdaVistaFlag = true; // Hay opciones

      this.cliSeleccionado = (opciones.id_cliente ?? '').toString();
      this.estadoSeleccionado = (opciones.estado ?? '').toString();
      this.estadoPreparacionSeleccionado = (
        opciones.estadoPreparacion ?? ''
      ).toString();
    }

    this.cargaClientes();
    this.cargaLista();

    this.modalClosedSubscription =
      this.modalFactSalidaSrv.modalClosed.subscribe(() => {
        // Suscribirse a modalClosed para saber cuando se cierra el modal y actualizar los datos de los pedidos
        console.log('El modal se ha cerrado con el pedido:');
        this.cargaPedidosList();
      });
  }

  cargaLista() {
    this.opcionesList.id_cliente = parseInt(this.cliSeleccionado);
    this.opcionesList.estado = parseInt(this.estadoSeleccionado);
    this.opcionesList.estadoPreparacion = parseInt(
      this.estadoPreparacionSeleccionado
    );

    this.loading = true;
    this.campanyaSrv.getListaFiltrada(this.opcionesList).subscribe((resp) => {
      this.loading = false;
      this.lista = resp.data;

      console.log(' __cargaLista() opcionesList', this.opcionesList);
      console.log(' __cargaLista()', this.lista);

      this.rows = this.lista;
      this.temp = [...this.lista];
    });
  }

  cargaClientes() {
    this.clientesSrv.getLista().subscribe((resp) => {
      this.loading = false;
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
    });
  }

  cargaPedidosList() {
    this.opcionesList.id = undefined;
    this.opcionesList.id_cliente = parseInt(this.cliSeleccionado);
    this.opcionesList.id_campanya = this.campSel.id;
    this.opcionesList.estado = undefined;
    this.opcionesList.estadoPreparacion = undefined;

    this.loading = true;
    this.pedidosSrv.getLista(this.opcionesList).subscribe((resp) => {
      this.loading = false;

      // ordenar por pedido_cli
      this.pedidosList = resp.data.sort(
        (a: { pedido_cli: string }, b: { pedido_cli: any }) =>
          a.pedido_cli.localeCompare(b.pedido_cli)
      );
      this.setTotalesPedidosList();
      this.sortDirectionPed = 'desc';
      this.ordenarPedidosCol('pedido_cli');

      // Guardar una copia de los pedidos
      this.pedidosListOriginal = this.pedidosList;

      // Montar y ordenar un array con los EAN's de todos los pedidos
      const eanSet = new Set<string>();
      this.pedidosList.forEach((pedido) => {
        if (Array.isArray(pedido.detall)) {
          pedido.detall.forEach((detalle) => {
            if (detalle?.artEan) {
              eanSet.add(detalle.artEan);
            }
          });
        } else {
          console.log(
            '__cargaPedidosList() No se encuentran líneas de detalle en algún pedido de esta campaña.'
          );
          return;
        }
      });
      this.eanArray = Array.from(eanSet).sort();

      console.log('__cargaPedidosList() opcionesList =', this.opcionesList);
      console.log('--> this.pedidosList =', this.pedidosList);
      console.log('--> this.sumaTotReferencias =', this.sumaTotReferencias);
      console.log('--> this.eanArray =', this.eanArray);
    });
  }

  setTotalesPedidosList() {
    this.sumaTotArticulos = this.pedidosList.reduce(
      (total, pedido) => total + pedido.tot_articulos!,
      0
    );
    this.sumaTotReferencias = this.pedidosList.reduce(
      (total, pedido) => total + pedido.tot_referencias!,
      0
    );
  }

  // Filtros

  onClienteSelect(id: string) {
    this.cliSeleccionado = id;
    this.cargaLista();
    this.campSel = {};
    this.pedidosList = [];
    this.pedidoDetall = {};
    this.pedidosSearch = '';
    this.strBuscarTodo = '';
  }

  onEstadoSelect(id: string) {
    this.estadoSeleccionado = id;
    this.cargaLista();
    this.campSel = {};
    this.pedidosList = [];
    this.pedidoDetall = {};
    this.pedidosSearch = '';
    this.strBuscarTodo = '';
  }

  onEstadoPreparacionSelect(id: string) {
    this.estadoPreparacionSeleccionado = id;
    this.cargaLista();
    this.campSel = {};
    this.pedidosList = [];
    this.pedidoDetall = {};
    this.pedidosSearch = '';
    this.strBuscarTodo = '';
  }

  onEanSelect(ean: string) {
    this.pedidosList = this.pedidosListOriginal;
    this.sumaCantidadesEan = 0;
    this.setTotalesPedidosList();
    if (ean === '') return;

    this.loading = true;

    this.pedidoDetall = {};
    this.pedidosList = this.pedidosList.filter((pedido) => {
      return pedido.detall!.some((detalle) => detalle.artEan!.includes(ean));
    });
    this.setTotalesPedidosList();

    // Averiguar la cantidad total de un EAN
    this.sumaCantidadesEan = this.pedidosList.reduce((total, pedido) => {
      const cantidad =
        Number(
          pedido.detall!.find((detalle) => detalle.artEan!.includes(ean))
            ?.cantidad
        ) ?? 0;
      return total + cantidad;
    }, 0);

    this.loading = false;

    console.log(' __onEanSelect() this.pedidosList=', this.pedidosList);
  }

  // Buscar campañas con un Pedido concreto
  buscarPedido(event: any) {
    const txt = event?.target?.value?.toUpperCase() ?? '';
    if (txt.length < 3) {
      this.notificSrv.aviso('warning', 'Mínimo 3 caracteres');
      return;
    }

    this.loading = true;
    this.campanyaSrv
      .campanyasListConPedido(this.pedidosSearch)
      .subscribe((resp) => {
        this.loading = false;

        console.log(' __buscarPedido cargaLista()', this.lista);

        if (resp.error) {
          this.notificSrv.aviso('error', resp.mensaje);
          return;
        }

        this.notificSrv.aviso('success', resp.mensaje);

        // Restablece los otros inputs
        this.cliSeleccionado = '';
        this.estadoSeleccionado = '';

        this.pedidosList = [];
        this.pedidoDetall = {};

        // carga datos de campañas en el dataTabe
        this.lista = resp.data;

        this.rows = this.lista;
        this.temp = [...this.lista];
      });
  }

  // Volver a cargar lista de campañas
  limpiaBuscaPedido() {
    this.pedidosSearch = '';
    this.cargaLista();
    const buscaTodoInput = document.getElementById('buscaPedido');
    buscaTodoInput?.focus();
  }

  //  ** CRUD ** //

  deleteRow(row: any) {
    this.infoClickCampanya(row);

    Swal.fire({
      title: '¿Borrar campaña?',
      icon: 'question',
      html: `Eliminar <b>${row.camp_cod}</b>`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.campanyaSrv.delete(row.id).subscribe((resp) => {
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
          } else {
            this.notificSrv.aviso('info', `Campaña ${row.camp_cod} eliminada`);
            this.rows = this.rows.filter((objeto: any) => objeto.id !== row.id);
            if (!this.rows.length) this.pedidosList = [];
            this.pedidosList = [];
            this.pedidoDetall = {};
          }
        });
      }
    });
  }

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr);
  }

  /// Búsqueda Global LISTA DE CAMPAÑAS ///

  buscarTodo() {
    const txt = this.strBuscarTodo?.toLowerCase() ?? '';
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );
    this.textoDestacado = txt;
    this.rows = temp;
    this.table = this.lista;
  }

  limpiaBusca() {
    this.strBuscarTodo = '';
    this.buscarTodo();
    const buscaTodoInput = document.getElementById('buscaTodo');
    buscaTodoInput?.focus();
  }

  /// Búsqueda Global LISTA DE PEDIDOS  ///

  buscarTodoPedidos() {
    const searchText = this.strBuscarTodoPedidos?.toLowerCase() ?? '';

    if (!searchText) {
      this.pedidosList = [...this.pedidosListOriginal];
      this.textoDestacadoPedidos = ''; // Reiniciar texto destacado
      return;
    }

    this.eanSeleccionado = ''; // Limpiar el EAN seleccionado
    this.sumaCantidadesEan = 0;

    this.pedidosList = this.pedidosListOriginal.filter((pedido: any) =>
      Object.values(pedido).some(
        (value) =>
          (typeof value === 'string' || typeof value === 'number') &&
          value.toString().toLowerCase().includes(searchText)
      )
    );

    this.textoDestacadoPedidos = searchText;
    this.setTotalesPedidosList();
  }

  resaltarTextoPedidos(value: string | null, textoDestacado: string): string {
    if (!value || !textoDestacado.trim()) return value ?? '';

    const regex = new RegExp(`(${textoDestacado})`, 'gi'); // Coincide con cualquier parte del texto
    return value.replace(regex, '<span class="resaltado">$1</span>'); // Resalta solo la coincidencia
  }

  limpiaBuscaPedidos() {
    this.strBuscarTodoPedidos = '';
    this.buscarTodoPedidos();
    const buscaTodoInput = document.getElementById('buscaTodoPedidos');
    buscaTodoInput?.focus();
  }

  //// AUX  ////

  // Estilo para la fila seleccionada
  getRowClass = (row: any) => {
    return {
      infoSelectRow: this.campSel && row.id === this.campSel.id,
    };
  };

  // Exportar a Excel
  exportToExcel(): void {
    const fileName = `campanyas-${new Date().toISOString()}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(this.rows);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  }

  guardaOpcionesList() {
    // guardar/borrar en localStore las opciones de la vista
    this.gurdaVistaFlag = !this.gurdaVistaFlag;
    if (this.gurdaVistaFlag) {
      localStorage.setItem('opcionesList', JSON.stringify(this.opcionesList));
      this.notificSrv.aviso('success', 'Opciones de vista guardadas');
    } else {
      localStorage.removeItem('opcionesList');
      this.notificSrv.aviso('warning', 'Opciones de vista eliminadas');
    }
  }

  getOpcionesListLocalStorage() {
    // Recupera de localStore las opciones de la vista
    const opcionesListString = localStorage.getItem('opcionesList');
    if (opcionesListString) {
      return JSON.parse(opcionesListString);
    }
    return {};
  }

  public literalTotal() {
    // Devuelve un string pasado por parámetro
    return 'Total:';
  }

  public sumaCeldas(cells: any[]) {
    // Devuelve la suma de la columna, formateada y sin decimales
    const filteredCells = cells.filter((cell) => !!cell);
    const sum: number = filteredCells.reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue),
      0
    );
    return sum.toLocaleString('de-DE');
  }

  // ** Selección de líneas  ** //

  onActivate(event: any) {
    if (event.type === 'click') {
      alert('onActivate');
      this.campSel = event.row;
      console.log('__Evento click  this.campSel', this.campSel);
      this.cargaPedidosList();
    }
  }

  infoClickCampanya(row: any) {
    // Info sobre una campaña

    this.campSel = row;
    console.log('__infoClickCampanya click  this.campSel', this.campSel);

    this.pedidosList = [];
    this.pedidoDetall = {};

    this.limpiaBuscaPedidos();
    this.eanSeleccionado = '';
    this.cargaPedidosList();
    this.onEanSelect('');

    // Destacar línea seleccionada en negrita
    this.rows.forEach((r: any) => {
      r.destacarLinea = false;
    });
    row.destacarLinea = true;
  }

  infoClickPedido(id_pedido: number) {
    // Info sobre un pedido
    this.pedidoDetall = {};
    this.opcionesList.id = id_pedido;
    this.opcionesList.uicsDelPedido = '1';
    this.opcionesList.addPedidoExternoData = '1';

    this.loading = true;
    this.pedidosSrv.getLista(this.opcionesList).subscribe((resp) => {
      this.loading = false;

      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje || 'Error desconocido');
        return;
      }
      this.pedidoDetall = resp.data[0];
      console.log('__infoClickPedido() pedidoDetall=', this.pedidoDetall);

      // Scroll hacia el elemento detallesPedido
      setTimeout(() => {
        const element = document.getElementById('detallesPedido');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100); // Un pequeño retraso para asegurar que la UI se ha actualizado
    });
  }

  descargaAlbaranClick(id_pedido: number) {
    console.log('__descargaAlbaranClick() id_pedido=', id_pedido);
    this.loading = true;
    this.pedidosSrv.downloadAlbaran(id_pedido).subscribe((resp) => {
      this.loading = false;
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje || 'Error desconocido');
        return;
      }
      const urlPdf: string = environment.pdfDir + '/' + resp.data;
      window.open(urlPdf, '_blank');
    });
  }



  // Descargar albarán en XLS
  descargaAlbaranXls(id_pedido: number) {
    const url = environment.xlsDir + '/albaranes' + `/albaran_${id_pedido}.xlsx`;
    console.log('__descargaAlbaranXls() url:', url);

    this.loading = true;

    // Verificar si el archivo existe comprobando el Content-Type
    fetch(url, { method: 'HEAD' })
      .then(response => {
        this.loading = false;
        const contentType = response.headers.get('Content-Type');

        // Verificar si es un archivo Excel (no JSON de error)
        const isExcelFile = contentType && (
          contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
          contentType.includes('application/vnd.ms-excel') ||
          contentType.includes('application/octet-stream')
        );

        if (response.ok && isExcelFile) {
          // El archivo Excel existe, abrirlo
          window.open(url, '_blank');
        } else {
          // El archivo no existe o es un JSON de error
          console.error('Archivo no encontrado. Status:', response.status, 'Content-Type:', contentType);
          this.notificSrv.aviso('error', 'El archivo Excel no está disponible');
        }
      })
      .catch(error => {
        this.loading = false;
        console.error('Error verificando archivo:', error);
        window.open(url, '_blank');
      });
  }




  openTracking(id_pedido: number) {
    this.loading = true;

    console.log('__openTracking() id_pedido', id_pedido);

    this.pedidosSrv.getPedido(id_pedido).subscribe((resp) => {
      this.loading = false;
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje || 'Error desconocido');
        return;
      }
      if (resp.data.ref_envio == null) {
        this.notificSrv.aviso(
          'warning',
          'No se ha encontrado referencia de envío para este pedido'
        );
        return;
      }
      console.log('__openTracking() resp.data', resp.data);
      const urlTracking = `${environment.url_cliente}/seg/${resp.data.cliNombreCorto}/?ref=${resp.data.ref_envio}`;
      window.open(urlTracking, '_blank');
    });
  }

  ordenarPedidosCol(columna: string) {
    if (this.sortColumnPed === columna) {
      this.sortDirectionPed = this.sortDirectionPed === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnPed = columna;
      this.sortDirectionPed = 'asc';
    }

    this.pedidosList.sort((a, b) => {
      let valueA = (a as any)[columna];
      let valueB = (b as any)[columna];

      // Convertir a número si ambos son numéricos y ambos son enteros
      const isNumeric =
        !isNaN(parseFloat(valueA)) && !isNaN(parseFloat(valueB));
      const isInteger =
        Number.isInteger(parseFloat(valueA)) &&
        Number.isInteger(parseFloat(valueB));
      if (isNumeric && isInteger) {
        valueA = parseFloat(valueA);
        valueB = parseFloat(valueB);
      } else {
        valueA = String(valueA).toLowerCase();
        valueB = String(valueB).toLowerCase();
      }

      if (valueA < valueB) return this.sortDirectionPed === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirectionPed === 'asc' ? 1 : -1;
      return 0;
    });
  }

  // Acciones especiales sobre el pedido
  accionEspecialPedidoClick(pedido: IPedido) {
    // Acciones especiales sobre un pedido
    this.infoClickPedido(pedido.id!); // Mostrar el detalle del pedido
    console.log('__accionEspecialPedidoClick() pedido', pedido);

    const inputOptions: { [key: string]: string } = {};
    const isNormalCampaign = this.campSel.campanyaTipo === 'Normal';
    const estadoPendiente =
      pedido.estado === Constantes.ESTADO_PEDIDO_PENDIENTE ||
      pedido.estado === Constantes.ESTADO_PEDIDO_EN_PREPARACION;

    // Definir todas las opciones
    inputOptions['0'] = 'Selecciona una opción';

    // Opción 1: Cancelar el pedido - Solo disponible si está pendiente
    inputOptions['1'] = estadoPendiente
      ? 'Cancelar el pedido'
      : '<span class="disabled-option">Cancelar el pedido</span>';

    // Opción 2: Servir con faltas - Solo disponible si está pendiente Y es campaña normal
    inputOptions['2'] =
      isNormalCampaign && estadoPendiente
        ? 'Servir con faltas'
        : '<span class="disabled-option">Servir con faltas</span>';

    // Opción 3: Preguntar al cliente - Solo disponible si está pendiente
    inputOptions['3'] = estadoPendiente
      ? 'Preguntar al cliente que acción tomar'
      : '<span class="disabled-option">Preguntar al cliente que acción tomar</span>';

    // Opción 4: Avisar al cliente - Siempre disponible
    inputOptions['4'] = 'Notificar al cliente sobre este pedido';

    Swal.fire({
      title: 'Acción sobre el pedido',
      html: `
      <style>
        .disabled-option {
          color: #ccc !important;
          font-style: italic;
        }
        .swal2-select option:disabled {
          color: #ccc;
          background-color: #f5f5f5;
        }
      </style>
      ¿Qué hacer con el pedido ${pedido.pedido_cli} de ${pedido.cliNombre}?
    `,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Seleccionar',
      input: 'select',
      inputOptions: inputOptions,
      didOpen: () => {
        // Deshabilitar opciones específicas después de que se abra el modal
        const selectElement = Swal.getInput() as unknown as HTMLSelectElement;
        if (selectElement) {
          // Deshabilitar opción 1 si NO está pendiente
          if (!estadoPendiente) {
            const option1 = selectElement.querySelector(
              'option[value="1"]'
            ) as HTMLOptionElement;
            if (option1) {
              option1.disabled = true;
              option1.style.color = '#ccc';
            }
          }

          // Deshabilitar opción 2 si NO está pendiente O no es campaña normal
          if (!estadoPendiente || !isNormalCampaign) {
            const option2 = selectElement.querySelector(
              'option[value="2"]'
            ) as HTMLOptionElement;
            if (option2) {
              option2.disabled = true;
              option2.style.color = '#ccc';
            }
          }

          // Deshabilitar opción 3 si NO está pendiente
          if (!estadoPendiente) {
            const option3 = selectElement.querySelector(
              'option[value="3"]'
            ) as HTMLOptionElement;
            if (option3) {
              option3.disabled = true;
              option3.style.color = '#ccc';
            }
          }
        }
      },
      inputValidator: (value) => {
        if (!value || value === '0') {
          return 'Debes seleccionar qué pasa con el pedido.';
        }

        // Validar que no se seleccione una opción deshabilitada
        if (value === '1' && !estadoPendiente) {
          return 'Solo se puede cancelar un pedido que está pendiente.';
        }

        if (value === '2' && (!isNormalCampaign || !estadoPendiente)) {
          if (!estadoPendiente) {
            return 'Esta opción solo está disponible para pedidos pendientes.';
          }
          if (!isNormalCampaign) {
            return 'Esta opción no está disponible para este tipo de campaña.';
          }
        }

        if (value === '3' && !estadoPendiente) {
          return 'Solo se puede preguntar al cliente cuando el pedido está pendiente.';
        }

        return null; // Devolver null si la validación pasa
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Solo procesar opciones válidas con sus respectivas condiciones
        if (result.value === '1' && estadoPendiente) {
          this.pedidoNoSale(pedido);
        }
        if (result.value === '2' && isNormalCampaign && estadoPendiente) {
          this.pedidoSaleParcial(pedido);
        }
        if (result.value === '3' && estadoPendiente) {
          this.pedidoPreguntarCliente(pedido);
        }
        if (result.value === '4') {
          this.avisarCliente(pedido);
        }
      }
    });
  }

  pedidoPreguntarCliente(pedido: IPedido) {
    Swal.fire({
      title: 'Preguntar al cliente',
      icon: 'info',
      html: `<b>¿Preguntar al cliente sobre su pedido ${pedido.pedido_cli}?</b><br>
      <small>
        <ul>
          <li>Se preguntará a ${pedido.cliNombre} sobre su pedido ${pedido.pedido_cli}.</li>
          <li>A partir de este momento, el Cliente tendrá activada la opción de <span class="text-info"><i>solicitar acciones especiales</i></span> para este pedido desde la Intranet. Siempre que el pedido siga en estado 'Pendiente'</li>
        </ul>
      </small>`,
      showCancelButton: true,
      cancelButtonText: 'Volver',
      confirmButtonText: 'Si, Mandar aviso',
    }).then((result) => {
      if (result.isConfirmed) {
        // Modificar registro del pedido y añadir un registro de aviso
        this.loading = true;
        this.pedidosSrv.marcarAviso(pedido.id!).subscribe((resp) => {
          this.loading = false;
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
            return;
          }

          this.cargaPedidosList(); // Actualizar lista de pedidos
          this.infoClickPedido(pedido.id!); // Mostrar el detalle del pedido
        });
      }
    });
  }

  campanyaAvisarCliente(row: any) {
    this.infoClickCampanya(row);

    Swal.fire({
      title: 'Avisar al cliente',
      icon: 'info',
      html: `<b>¿Avisar al cliente ${row.cliNombre} sobre TODOS sus pedidos pendientes de esta campaña?</b><br>
      <small>
        <ul>
          <li>A partir de este momento, el Cliente tendrá activada la opción de <span class="text-info"><i>solicitar acciones especiales</i></span> para estos pedidos desde la Intranet. Siempre que el pedido siga en estado 'Pendiente'</li>
        </ul>
      </small>`,
      showCancelButton: true,
      cancelButtonText: 'Volver',
      confirmButtonText: 'Si, Mandar aviso',
    }).then((result) => {
      if (result.isConfirmed) {
        // Modificar los registros de los pedidos y añadir un registro de aviso de campaña
        this.loading = true;
        this.pedidosSrv.marcarAvisoCampanya(row!).subscribe((resp) => {
          console.log('__campanyaAvisarCliente()', resp);
          this.loading = false;
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
            return;
          }
          this.notificSrv.aviso('success', resp.mensaje);

          this.cargaPedidosList(); // Actualizar lista de pedidos
          this.infoClickCampanya(row); // Mostrar el detalle del pedido
        });
      }
    });
  }

  pedidoNoSale(pedido: IPedido) {
    console.log('__pedidoNoSale ', pedido);
    // El pedido NO va a salir, confirmar
    const id_pedido = pedido.id!;

    Swal.fire({
      title: 'Cancelar pedido',
      icon: 'warning',
      html: `<b>¿Quieres cancelar este pedido?</b><br>
      <small style="text-align: left;">
        <ul style="list-style: none; padding-left: 0;">
          <li>1. Si el pedido aún NO se ha empezado a recoger, se cancelarán sus recogidas y preparaciones.</li>
          <li>2. Se generarán transacciones para descontar la mercancía de los artículos del pedido.</li>
          <li>3. Se prepara una entrada en stock con los artículos de ese pedido (están en el/los carros o en el cajetín)</li>
          <li>4. Se marca el estado del pedido como <i>Cancelado</i> </li>
        </ul>
      </small>`,
      showCancelButton: true,
      cancelButtonText: 'Volver',
      confirmButtonText: 'Si, Cancelar pedido',
    }).then((result) => {
      if (result.isConfirmed) {
        this.pedidoNoSaleConfirm(pedido);
      }
    });
  }

  pedidoNoSaleConfirm(pedido: IPedido) {
    // El pedido NO va a salir, confirmado

    const id_pedido = pedido.id!;
    let apiData: any = {};

    this.loading = true;
    const userdata: IUsuario = this.usuarioSrv.userdata;

    apiData = { ...apiData, id_pedido, userdata };
    console.table('__apiData', apiData);

    this.repartosSrv.pedidoNoSale(apiData).subscribe((resp) => {
      this.loading = false;
      console.log('El pedido NO va a salir:', resp);

      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje);
      }
      this.notificSrv.aviso('success', resp.mensaje);

      // Mandar aviso de cancelación via la intranet del cliente
      const data = {
        id_cliente: pedido.id_cliente,
        tipo: Constantes.AVISO_TIPO_PEDIDO,
        buscar_pedido: pedido.id,
        mensaje: `El pedido ${pedido.pedido_cli} ha sido cancelado.`,
      };

      this.avisosSrv.avisoNew(data).subscribe((resp) => {
        console.log('__avisosSrv.avisoNew()', resp);
      });

      this.cargaPedidosList(); // Actualizar lista de pedidos para mostrar cambios de estado
      this.infoClickPedido(id_pedido); // Mostrar el detalle del pedido
    });
  }

  pedidoSaleParcial(pedido: IPedido) {
    // El pedido va a salir como está, Servir con faltas

    if ((this.pedidoDetall?.tot_cant_repartida ?? 0) == 0) {
      this.notificSrv.aviso(
        'warning',
        'No se puede marcar un pedido como SERVIDO CON FALTAS si no tiene artículos repartidos'
      );
      return;
    }

    const id_pedido = pedido.id!;

    let lineas: ILineas[] = [];
    let apiData: any = {};

    this.loading = true;
    this.pedidosSrv.getArticulosPendientes(id_pedido).subscribe(
      async (resp) => {
        this.loading = false;
        console.log('__getArticulosPendientes: id_pedido', id_pedido);
        console.log('__getArticulosPendientes resp:', resp);
        apiData = resp.data;
        const pedido_cli: string = resp.data.pedido.pedido_cli;

        lineas = resp.data.articulos_pendientes.map((art: any) => {
          const cantidad = +art.cantidad || 0;
          const cant_repartir = +art.cant_repartir || 0;
          const cant_repartida = +art.cant_repartida || 0;
          const idArticulo = art.id_articulo || (art.articulo ? art.articulo.id : null);
          return {
            id_articulo: idArticulo,
            ean: art.ean,
            sku: art.sku,
            descripcion: art.descripcion,
            foto: art.foto,
            cantidad: cantidad,
            cant_repartir: cant_repartir,
            cant_repartida: cant_repartida,
            cant_devuelta: cant_repartir - cant_repartida,

            selectOptions: [
              { value: 'Anulado', label: 'Anulado' },
              { value: 'Rotura', label: 'Rotura' },
              { value: 'Extraviado', label: 'Extraviado' },
            ],
          };
        });

        if (!lineas.length) {
          this.notificSrv.aviso('error', 'Este pedido NO tiene ningún artículo a repartir con faltas');
          return;
        }

        const datosPedido = {
          pedido_cli: pedido_cli,
          lineas: lineas,
        };

        if (resp.error) {
          this.notificSrv.aviso('error', resp.mensaje);
          return;
        }
        // this.notificSrv.aviso('success', resp.mensaje);

        const formValues = await this.mostrarFormularioDinamico(datosPedido);

        if (formValues) {
          const userdata: IUsuario = this.usuarioSrv.userdata;
          apiData = {
            ...apiData,
            formValues,
            userdata,
          };

          console.table('__apiData', apiData);

          this.loading = true;
          this.loadingAlbaran = true;

          this.repartosSrv.pedidoServirConFaltas(apiData).subscribe((resp) => {
            this.loading = false;
            this.loadingAlbaran = false;

            console.log('__pedidoSaleConFaltas apiData', apiData);
            console.log('__pedidoSaleConFaltas resp', resp);

            if (resp.error) {
              this.notificSrv.aviso('error', resp.mensaje);
              return;
            }
            this.notificSrv.aviso(
              'info',
              `Generadas ${resp.totales.conta.transacciones} transacciones y ${resp.totales.conta.entradas} entradas en stock`
            );
            this.notificSrv.aviso('success', resp.mensaje);

            // Mandar aviso de servido con faltas via la intranet del cliente
            const data = {
              id_cliente: pedido.id_cliente,
              tipo: Constantes.AVISO_TIPO_PEDIDO,
              buscar_pedido: pedido.id,
              mensaje: `El pedido ${pedido.pedido_cli} ha sido cancelado.`,
            };

            this.avisosSrv.avisoNew(data).subscribe((resp) => {
              console.log('__avisosSrv.avisoNew()', resp);
            });

            this.cargaPedidosList(); // Actualizar lista de pedidos para mostrar cambios de estado
            this.infoClickPedido(id_pedido); // Mostrar el detalle del pedido
          });
        }

        return;
      }
    );
  }

  async mostrarFormularioDinamico(datosPedido: any) {
    const inputs = datosPedido.lineas;

    const tableRowsHTML = inputs
      .map((input: ILineas, index: any) => {
        const selectOptionsHTML = input.selectOptions
          .map(
            (option) =>
              `<option value="${option.value}">${option.label}</option>`
          )
          .join('');

        return `
          <tr> 
            <td style="white-space: nowrap;">${input.ean}</td>
            <td style="white-space: nowrap;">${input.sku}</td>
            <td class="small">${this.funcLib.limitarYAgregarPuntos(input.descripcion, 80)}</td>
            <td>${input.cantidad}</td>
            <td>${input.cant_repartir}</td>
            <td>${input.cant_repartida}</td>             
            <td ${input.cant_devuelta > 0 ? 'style="background-color: #ffcccc;"' : ''}>${input.cant_devuelta}</td>
            <td>
              <select id="swal-select${index}" class="form-control">
                ${selectOptionsHTML}
              </select>
            </td>
          </tr>
        `;
      })
      .join('');

    let subTituloHTML = `Estos artículos <b>NO</b> se van a incluir en el envío del pedido <b>${datosPedido.pedido_cli}</b>`;
    subTituloHTML += `<p style="font-size: small"><b><span style="color: red;">IMPORTANTE:</span></b> Debes asegurarte de que los carros UIC's de esta recogida ya no se están utilizando.</p>`;

    const tableHTML = `
      <table class="table table-bordered table-striped">
        <thead>
          <tr> 
            <th style="white-space: nowrap;">EAN</th>
            <th style="white-space: nowrap;">SKU</th>
            <th>Descripción</th>
            <th style="white-space: nowrap;">Pedido</th>
            <th style="white-space: nowrap;">Recogido</th>
            <th style="white-space: nowrap;">Preparado</th> 
            <th style="white-space: nowrap;">A Devolver</th>
            <th>Motivo</th>
          </tr>
        </thead>
        <tbody>
          ${tableRowsHTML}
        </tbody>
      </table>
    `;
    const avisosHTML = `
    <span style="font-size: small; margin-top: 10px;">
        <p>Para los artículos con Cantidad Preparada se creará una transacción de recuento por el motivo indicado en cada línea.<br>
       Se creará la entrada <b>${datosPedido.pedido_cli}-DEV</b> con los artículos que se encuentren en los UIC's de la recogida y no han sido incluidos en el pedido</p>
    </span>`;

    const { value: formValues } = await Swal.fire({
      title: 'El pedido se sirve con faltas',
      width: '80%',
      html: subTituloHTML + tableHTML + avisosHTML,
      footer: 'Se va a crear el albarán y el archivo csv de transporte',

      confirmButtonText: 'Confirmar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',

      focusConfirm: false,
      preConfirm: () => {
        return inputs.map(
          (input: ILineas, index: number) => {
            const selectElement = document.getElementById(
              `swal-select${index}`
            ) as HTMLSelectElement | null;
            const selectValue = selectElement?.value || '';

            return {
              id_articulo: input.id_articulo,
              cantidad: input.cantidad,
              cant_repartir: input.cant_repartir || 0,
              cant_repartida: input.cant_repartida || 0,
              cant_devuelta: input.cant_repartir - (input.cant_repartida || 0),
              selectValue,
            };
          }
        );
      },
    });

    // if (formValues) {
    //   Swal.fire(JSON.stringify(formValues));
    // } else {
    //   alert('Sin valores en formValues');
    // }

    return formValues;
  }

  avisarCliente(pedido: IPedido) {
    Swal.fire({
      title: '<i class="fa-solid fa-laptop"></i> Enviar notificación',
      text: `Escribe el mensaje para ${pedido.cliNombre} referente a su pedido`,
      input: 'textarea',
      inputValue: `Referente al pedido ${pedido.pedido_cli}...`,
      inputPlaceholder: 'Escribe tu mensaje aquí...',
      showCancelButton: true,
      confirmButtonText: 'Enviar notificación',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      inputValidator: (value) => {
        if (!value || value.trim().length < 4) {
          return 'El mensaje debe contener al menos 4 caracteres';
        }
        return null;
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const texto = result.value.trim();
        const data: any = {
          id_cliente: pedido.id_cliente,
          tipo: Constantes.AVISO_TIPO_PEDIDO,
          buscar_pedido: pedido.id,
          mensaje: texto,
        };

        this.avisosSrv.avisoNew(data).subscribe((resp) => {
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
            return;
          }
          this.notificSrv.aviso('success', resp.mensaje);
        });
      }
    });
  }

  /// FIN ACCIONES ESPECIALES ///


  // MODAL AVISOS
  abrirModalAvisos(pedido: IPedido) {
    this.infoClickPedido(pedido.id!);
    //   this.notificSrv.aviso('info', `Notificaciones del pedido ${pedido.pedido_cli}`)
    this.modalAvisoPedidoSrv.pedido = pedido;
    this.modalAvisoPedidoSrv.abrirModal();

    // Subscribe to the modalClosed event
    this.modalAvisoPedidoSrv.modalClosed.subscribe(() => {
      console.log('El modalAvisoPedido ha sido cerrado!');
    });
  }

  // MODAL FACTURACION
  abrirModalFacturacion(pedido: IPedido, rowIndex: number) {
    this.modalFactSalidaSrv.pedido = pedido;
    this.pedidoDetall = pedido;
    this.modalFactSalidaSrv.abrirModal();

    // Subscribe to the modalClosed event
    const sub = this.modalFactSalidaSrv.modalClosed.subscribe(() => {
      console.log('_El modal se ha cerrado con el pedido:', pedido);
      this.actualizarLineaPedido(pedido, rowIndex);
      //Cancelar suscripción para evitar memory leaks
      sub.unsubscribe();
    });
  }

  // MODAL PEDIDO CABECERA
  abrirModalCabeza(pedido: IPedido, rowIndex: number) {
    this.modalPedidosCabeceraSrv.pedido = pedido;
    this.modalPedidosCabeceraSrv.abrirModal();

    // Subscribe to the modalClosed event
    const sub = this.modalPedidosCabeceraSrv.modalClosed.subscribe(() => {
      console.log('_El modal se ha cerrado con el pedido:', pedido);

      this.actualizarLineaPedido(pedido, rowIndex);
      //Cancelar suscripción para evitar memory leaks
      sub.unsubscribe();
    });
  }

  // MODAL PEDIDO ORIGEN
  abrirModalOrigenPedido(pedido: IPedido, rowIndex: number) {

    console.log('_abrirModalOrigenPedido con el pedido:', pedido, rowIndex);

    this.modalPedidoOrigenSrv.pedido = pedido;
    this.modalPedidoOrigenSrv.abrirModal();

    // Subscribe to the modalClosed event
    const sub = this.modalPedidoOrigenSrv.modalClosed.subscribe(() => {
      console.log('_El modal se ha cerrado con el pedido:', pedido);
      //Cancelar suscripción para evitar memory leaks
      sub.unsubscribe();
    });
  }


  // Crear pedido complementario
  crearComplementario(pedido: IPedido, rowIndex: number) {
    console.log('_crearComplementario con el pedido:', pedido, rowIndex);
    let texto = `¿Quieres crear un pedido complementario para el pedido <b>${pedido.pedido_cli}</b> con los artículos NO servidos?`;
    if (pedido.i_complemetarios) {
      texto = `<h1 class="text-danger">Atención</h1><br>El pedido <b>${pedido.pedido_cli}</b> ya tiene pedidos complementarios, asegurate de no duplicar pedidos`;
    }
    Swal.fire({
      title: '¿Crear complementario?',
      html: texto,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, crear',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.pedidosSrv.crearComplementario(pedido.id!).subscribe((resp: any) => {
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
            return;
          }
          this.notificSrv.aviso('success', 'Pedido complementario creado');
          this.infoClickPedido(pedido.id!);
        });
      }
    });
  }

  private actualizarLineaPedido(pedido: IPedido, rowIndex: number) {
    // Actualizar la fila del pedido modificado
    const opciones: IListaOpciones = { id: pedido.id };
    this.pedidosSrv.getLista(opciones).subscribe((resp: any) => {
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje);
        return;
      }
      pedido = resp.data[0];
      const newRows = [...this.pedidosList];
      newRows[rowIndex] = { ...pedido };

      // Reasignamos para que ngx-datatable detecte cambios
      this.pedidosList = newRows;
      console.log(
        '__se ha modificado this.rows[rowIndex] :',
        rowIndex,
        this.pedidosList[rowIndex]
      );
    });
  }

  pdfEtiquetaPedido(pedido: IPedido) {
    // Imprimir una etiqueta del pedido

    console.log('__imprimeEtiqueta() ', pedido);

    const data = {
      id_pedido: pedido.id,
      id_usuario: this.usuarioSrv.userdata.id,
    };

    Swal.fire({
      title: 'Imprimir etiqueta',
      text: `¿Imprimir la etiqueta del pedido ${pedido.pedido_cli}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, imprimir',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.pedidosSrv.pedidoLabel(data).subscribe((resp) => {
          this.loading = false;
          console.log('__pedidoLabel', resp);
          this.notificSrv.aviso('info', resp.mensaje);
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
          }
        });
      }
    });
  }

  generaXlsEnvio(pedido: IPedido) {
    // Genera el archivo XLS de envío de un pedido

    console.log('__generaXlsEnvio() ', pedido);

    const data = {
      id_pedido: pedido.id,
      id_usuario: this.usuarioSrv.userdata.id,
    };

    Swal.fire({
      title: 'Generar Etiqueta de envío',
      text: `¿Generar XLS para exportar el pedido a DTX?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, generar etiqueta',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.repartosSrv.endpointGeneraXlsEnvio(data).subscribe((resp) => {
          this.loading = false;
          console.log('__generaXlsEnvio()', resp);
          this.notificSrv.aviso('info', resp.mensaje);
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
          }
        });
      }
    });
  }

  generaPdfEnvio(pedido: IPedido) {
    // Genera el archivo PDF de envío de un pedido

    console.log('__generaPdfEnvio() ', pedido);

    const todoReparido =
      pedido.tot_cant_repartir! > 0 &&
      pedido.tot_cant_repartir === pedido.tot_cant_repartida &&
      pedido.tot_cant_repartir === pedido.tot_articulos;

    const data = {
      id_pedido: pedido.id,
      id_usuario: this.usuarioSrv.userdata.id,
    };

    let text = `¿Generar el albarán Packing List del pedido ${pedido.pedido_cli}?`;
    if (todoReparido && pedido.estado !== Constantes.ESTADO_PEDIDO_SERVIDO) {
      text = `${text} <br><span style="color: green; font-weight: bold;">El estado del pedido pasará a serivido</span>`;
    }

    Swal.fire({
      title: 'Generar Packing List de envío',
      html: text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, generar documento',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.repartosSrv.pdfAlbaran(data).subscribe((resp) => {
          this.loading = false;
          console.log('__generaPdfEnvio()', resp);
          this.notificSrv.aviso('info', resp.mensaje);
          this.descargaAlbaranClick(pedido.id!);
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
            return;
          }
          if (
            todoReparido &&
            pedido.estado !== Constantes.ESTADO_PEDIDO_SERVIDO
          ) {
            this.cambiaEstadoPedido(
              pedido.id!,
              parseInt(Constantes.ESTADO_PEDIDO_SERVIDO)
            );
          }
        });
      }
    });
  }


  labelCajas(pedido: IPedido) {
    // Imprime el contenido de las cajas de un pedido
    console.log('__labelCajas() ', pedido);

    this.getInfoCajas(pedido.id!).subscribe(infoCajas => {
      if (!infoCajas || !infoCajas.length) {
        this.notificSrv.aviso('info', 'No hay información de cajas para este pedido.');
        return;
      }

      // Filtrar cajas con número 0
      infoCajas = infoCajas.filter((item: any) => Number(item.caja_num) !== 0);

      if (!infoCajas.length) {
        this.notificSrv.aviso('info', 'No hay información de cajas para este pedido.');
        return;
      }

      // Obtener cajas únicas
      const cajasUnicas = [...new Map(
        infoCajas.map((item: any) => [item.caja_num, item])
      ).values()].sort((a: any, b: any) => Number(a.caja_num) - Number(b.caja_num));

      // Crear opciones para el select
      const selectOptions: Record<string, string> = cajasUnicas.reduce((options: Record<string, string>, caja: any) => {
        if (caja.caja_uic) {
          options[caja.caja_num] = `Caja ${caja.caja_num} - ${caja.caja_uic}`;
        } else {
          options[caja.caja_num] = `Caja ${caja.caja_num}`;
        }
        return options;
      }, { 'todas': 'Imprimir todas las cajas' });

      Swal.fire({
        title: 'Imprimir contenido de cajas',
        text: `Selecciona qué caja imprimir del pedido ${pedido.pedido_cli}`,
        icon: 'question',
        input: 'select',
        inputOptions: selectOptions,
        inputPlaceholder: 'Selecciona una caja',
        showCancelButton: true,
        confirmButtonText: 'Imprimir',
        cancelButtonText: 'Cancelar',
        inputValidator: (value) => {
          if (!value) {
            return 'Debes seleccionar alguna caja';
          }
          return null;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          const cajaSeleccionada = result.value;

          const data = {
            id_pedido: pedido.id,
            id_usuario: this.usuarioSrv.userdata.id,
            caja_num: cajaSeleccionada === 'todas' ? null : cajaSeleccionada
          };

          this.loading = true;
          this.pedidosSrv.labelCajas(data).subscribe((resp) => {
            this.loading = false;
            console.log('__labelCajas()', resp);
            this.notificSrv.aviso('info', resp.mensaje);
            if (resp.error) {
              this.notificSrv.aviso('error', resp.mensaje);
            }
          });
        }
      });
    });
  }


  getInfoCajas(id_pedido: number): Observable<any> {
    this.loading = true;
    return this.repartosSrv.getRepartoCajas(id_pedido).pipe(
      map(resp => {
        this.loading = false;
        console.log('__getRepartoCajas()', resp);
        if (resp.error) {
          this.notificSrv.aviso('error', resp.mensaje);
          return null;
        }
        return resp.data;
      })
    );
  }




  cambiaEstadoPedido(id: number, nuevoEstado: number) {
    // Cambia el estado del pedido sin más
    const data = {
      id: id,
      nuevoEstado: nuevoEstado,
    };

    this.loading = true;
    this.pedidosSrv.cambiaEstadoPedido(data).subscribe((resp) => {
      this.loading = false;
      console.log('__cambiaEstadoPedido()', resp);
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje);
        return;
      }
      this.notificSrv.aviso('info', resp.mensaje);
      this.infoClickCampanya(this.campSel!); // Recargar la lista de pedidos
    });
  }

  editUbicaciones(campanya: ICampanya) {
    // Redirigir a reubicar/campanya.camp_cod
    console.log('__editUbicaciones() ', campanya);
    this.router.navigateByUrl(`panel/campanya_reubicar/${campanya.id}`);
  }

}
